import { MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { COLOR_BLACK_HAZE, COLOR_DENIM, COLOR_REGENT_ST_BLUE } from '../../popTheme';

export const YearSelect = ({ sxprops, inputProps, ...props }) => {
  const renderYears = (minYear, maxYearOffset) => {
    let years = [];
    for (let i = new Date().getFullYear() - maxYearOffset; i >= minYear; i--) {
      years.push(
        <MenuItem key={i} value={i}>
          <Typography variant="body1" color={COLOR_DENIM}>
            {i}
          </Typography>
        </MenuItem>,
      );
    }
    return years;
  };
  return (
    <Select
      {...props}
      fullWidth
      size="small"
      inputProps={{ ...inputProps }}
      sx={{
        ...sxprops,
        bgcolor: COLOR_BLACK_HAZE,
        borderRadius: '0.375rem',
        borderColor: COLOR_REGENT_ST_BLUE,
      }}
    >
      {renderYears(1990, 8)}
    </Select>
  );
};
